// extracted by mini-css-extract-plugin
export default {"content":"loading_content__YyNV-"};